import dayjs from 'dayjs'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import {
  filtrosArrayBarra,
  revelarBarraFiltragem,
  mudarFiltros,
  limpadorFiltros
} from '../../../redux/actions'
import { useGlobal } from '../../../stores/useGlobal'
import decryptJWT from '../../../utils/decryptJWT'
import {
  formatDateToDatePicker,
  formatStringToNumberArray
} from '../../../utils/genericFormatters'
import DatePicker from '../../Mantine/DatePicker'
import Grid from '../../Mantine/Grid'
import Input from '../../Mantine/Input'
import Modal from '../../Mantine/Modal'
import MultiSelect from '../../Mantine/MultiSelect'

import * as S from './styles'


const REACT_QUERY_OPTIONS = {
  keepPreviousData: true,
  refetchOnWindowFocus: false
}

const WIDTH_COLUMNS = [3, 3, 3, 3]

const DEFAULT_FILTERS_VALUES = {
  dsPlano: [],
  dsFornecedor: [],
  dsCicloVida: [],
  filtroDataCompraInicio: null,
  filtroDataCompraFinal: null,
  filtroDataContratoInicio: null,
  filtroDataContratoFinal: null,
  filtroDataAtivacaoInicio: null,
  filtroDataAtivacaoFinal: null,
  filtroValorMinimo: null,
  filtroValorMaximo: null,
  filtroCliente: null
}

export default function FiltroSimcardsVirgens({ opened, close }) {
  const { setIsLoadingGlobal, setMostrarNotificacao } = useGlobal()
  const [filterOptions, serFilterOptions] = useState({
    cicles: [],
    suppliers: [],
    plans: []
  })
  const [localFilters, setLocalFilters] = useState({
    ...DEFAULT_FILTERS_VALUES
  })
  const [dateErrors, setDateErrors] = useState({
    purchase: false,
    contract: false,
    activation: false
  })

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let arrayFiltrosSimcard = []

  const despacho = useDispatch()
  const cd_pav_usuario = decryptJWT('codigo')

  useEffect(() => {
    if (!filtros?.vazio) {
      const auxFilter = {
        ...DEFAULT_FILTERS_VALUES
      }
      if (filtros?.VALOR_MIN) auxFilter.filtroValorMinimo = filtros.VALOR_MIN
      if (filtros?.VALOR_MAX) auxFilter.filtroValorMaximo = filtros.VALOR_MAX
      if (filtros?.DS_CLIENTE) {
        auxFilter.filtroCliente = filtros.DS_CLIENTE
      }
      if (filtros?.CD_PLANO)
        auxFilter.dsPlano = formatStringToNumberArray(filtros.CD_PLANO)
      if (filtros?.CD_CICLO_VIDA)
        auxFilter.dsCicloVida = formatStringToNumberArray(filtros.CD_CICLO_VIDA)
      if (filtros?.CD_FORNECEDOR)
        auxFilter.dsFornecedor = formatStringToNumberArray(
          filtros.CD_FORNECEDOR
        )
      if (filtros?.DATA_COMPRA_FIM)
        auxFilter.filtroDataCompraFinal = formatDateToDatePicker(
          dayjs(filtros.DATA_COMPRA_FIM).format("YYYY-MM-DD")
        )
      if (filtros?.DATA_CONTRATO_FIM)
        auxFilter.filtroDataContratoFinal = formatDateToDatePicker(
          dayjs(filtros.DATA_CONTRATO_FIM).format("YYYY-MM-DD")
        )
      if (filtros?.DATA_ATIVACAO_FIM)
        auxFilter.filtroDataAtivacaoFinal = formatDateToDatePicker(
          dayjs(filtros.DATA_ATIVACAO_FIM).format("YYYY-MM-DD")
        )
      if (filtros?.DATA_COMPRA_INICIO)
        auxFilter.filtroDataCompraInicio = formatDateToDatePicker(
          dayjs(filtros.DATA_COMPRA_INICIO).format("YYYY-MM-DD")
        )
      else auxFilter.filtroDataCompraFinal = null
      if (filtros?.DATA_CONTRATO_INICIO)
        auxFilter.filtroDataContratoInicio = formatDateToDatePicker(
          dayjs(filtros.DATA_CONTRATO_INICIO).format("YYYY-MM-DD")
        )
      else auxFilter.filtroDataContratoFinal = null
      if (filtros?.DATA_ATIVACAO_INICIO)
        auxFilter.filtroDataAtivacaoInicio = formatDateToDatePicker(
          dayjs(filtros.DATA_ATIVACAO_INICIO).format("YYYY-MM-DD")
        )
      else auxFilter.filtroDataAtivacaoFinal = null

      setLocalFilters(auxFilter)
      validateDates(auxFilter)
    }
  }, [filtros])

  const validateDates = (filters) => {
    const errors = {
      purchase: false,
      contract: false,
      activation: false
    }

    if (
      (filters.filtroDataCompraInicio || filters.filtroDataCompraFinal) &&
      (!filters.filtroDataCompraInicio || !filters.filtroDataCompraFinal)
    ) {
      errors.purchase = true
    }
    if (
      (filters.filtroDataContratoInicio || filters.filtroDataContratoFinal) &&
      (!filters.filtroDataContratoInicio || !filters.filtroDataContratoFinal)
    ) {
      errors.contract = true
    }
    if (
      (filters.filtroDataAtivacaoInicio || filters.filtroDataAtivacaoFinal) &&
      (!filters.filtroDataAtivacaoInicio || !filters.filtroDataAtivacaoFinal)
    ) {
      errors.activation = true
    }

    setDateErrors(errors)
  }

  const getFilters = async () => {
    setIsLoadingGlobal(true)
    try {
      const [cicles, suppliers, plans] = await Promise.all([
        fetchData('fat_ciclo_de_vida_2'),
        fetchData('fat_fornecedor'),
        fetchData('plans')
      ])

      const toOptions = (data) =>
        data?.map((item) => ({
          value: item.codigo,
          label: item.descricao1
        })) ?? []

      serFilterOptions((prev) => ({
        ...prev,
        cicles: toOptions(cicles?.data?.dados),
        suppliers: toOptions(suppliers?.data?.dados),
        plans: toOptions(plans?.data?.dados)
      }))
    } finally {
      setIsLoadingGlobal(false)
    }
  }

  function handleFuncaoEstadosRedux() {
    if (dateErrors.purchase || dateErrors.contract || dateErrors.activation) {
      setMostrarNotificacao({
        show: true,
        type: 'error',
        title: 'Erro ao aplicar filtros',
        message:
          'Não foi possível filtrar os dados. Verifique os filtros e tente novamente.',
        autoHide: 5000
      })

      return
    }

    if (localFilters.dsPlano.length > 0) {
      localFilters?.dsPlano?.forEach((item) => {
        const plano = filterOptions?.plans?.find((e) => e.value === item)
        arrayFiltrosSimcard.push('Plano: ' + plano?.label + '?CD_PLANO')
      })
    }
    if (localFilters.dsFornecedor.length > 0) {
      localFilters?.dsFornecedor?.forEach((item) => {
        const plano = filterOptions?.suppliers?.find((e) => e.value === item)
        arrayFiltrosSimcard.push(
          'Fornecedor: ' + plano?.label + '?CD_FORNECEDOR'
        )
      })
    }
    if (localFilters.dsCicloVida.length > 0) {
      localFilters?.dsCicloVida?.forEach((item) => {
        const plano = filterOptions?.cicles?.find((e) => e.value === item)
        arrayFiltrosSimcard.push(
          'Ciclo de Vida: ' + plano?.label + '?CD_CICLO_VIDA'
        )
      })
    }
    if (
      localFilters.filtroDataCompraInicio !== '' &&
      localFilters.filtroDataCompraFinal !== '' &&
      localFilters.filtroDataCompraInicio &&
      localFilters.filtroDataCompraFinal
    ) {
      arrayFiltrosSimcard.push(
        'Data de compra: entre ' +
          moment(localFilters.filtroDataCompraInicio).format('DD-MM-YYYY') +
          ' e ' +
          moment(localFilters.filtroDataCompraFinal).format('DD-MM-YYYY') +
          '?DATA_COMPRA_INICIO'
      )
    }
    if (
      localFilters.filtroDataContratoInicio !== '' &&
      localFilters.filtroDataContratoFinal !== '' &&
      localFilters.filtroDataContratoInicio &&
      localFilters.filtroDataContratoFinal
    ) {
      arrayFiltrosSimcard.push(
        'Prazo do contrato: entre ' +
          moment(localFilters.filtroDataContratoInicio).format('DD-MM-YYYY') +
          ' e ' +
          moment(localFilters.filtroDataContratoFinal).format('DD-MM-YYYY') +
          '?DATA_CONTRATO_INICIO'
      )
    }
    if (
      localFilters.filtroDataAtivacaoInicio !== '' &&
      localFilters.filtroDataAtivacaoFinal !== '' &&
      localFilters.filtroDataAtivacaoInicio &&
      localFilters.filtroDataAtivacaoFinal
    ) {
      arrayFiltrosSimcard.push(
        'Data de ativação: entre ' +
          moment(localFilters.filtroDataAtivacaoInicio).format('DD-MM-YYYY') +
          ' e ' +
          moment(localFilters.filtroDataAtivacaoFinal).format('DD-MM-YYYY') +
          '?DATA_ATIVACAO_INICIO'
      )
    }
    if (
      localFilters.filtroValorMinimo !== '' &&
      localFilters.filtroValorMaximo !== '' &&
      localFilters.filtroValorMinimo &&
      localFilters.filtroValorMaximo
    ) {
      arrayFiltrosSimcard.push(
        'Valor: entre ' +
          formatValue(localFilters.filtroValorMinimo) +
          ' e ' +
          formatValue(localFilters.filtroValorMaximo) +
          '?VALOR_MIN'
      )
    } else if (
      localFilters.filtroValorMinimo !== '' &&
      localFilters.filtroValorMinimo
    ) {
      arrayFiltrosSimcard.push(
        'Valor: a partir de ' +
          formatValue(localFilters.filtroValorMinimo) +
          '?VALOR_MIN'
      )
    } else if (
      localFilters.filtroValorMaximo !== '' &&
      localFilters.filtroValorMaximo
    ) {
      arrayFiltrosSimcard.push(
        'Valor: até ' +
          formatValue(localFilters.filtroValorMaximo) +
          '?VALOR_MAX'
      )
    }
    if (localFilters.filtroCliente !== '' && localFilters.filtroCliente) {
      arrayFiltrosSimcard.push(
        'Cliente: ' + localFilters.filtroCliente + '?DS_CLIENTE'
      )
    }

    // despacho(maximoTagsExibidas(false))
    formatFiltersToApply()
    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
    despacho(revelarBarraFiltragem(true))
    close()
  }

  const formatFiltersToApply = () => {
    const filters = {
      ...(localFilters.dsCicloVida.length > 0 && {
        CD_CICLO_VIDA: localFilters.dsCicloVida.join(',')
      }),
      ...(localFilters.dsFornecedor.length > 0 && {
        CD_FORNECEDOR: localFilters.dsFornecedor.join(',')
      }),
      ...(localFilters.dsPlano.length > 0 && {
        CD_PLANO: localFilters.dsPlano.join(',')
      }),
      ...(localFilters.filtroDataCompraInicio && {
        DATA_COMPRA_INICIO: localFilters.filtroDataCompraInicio
      }),
      ...(localFilters.filtroDataCompraFinal && {
        DATA_COMPRA_FIM: localFilters.filtroDataCompraFinal
      }),
      ...(localFilters.filtroDataContratoInicio && {
        DATA_CONTRATO_INICIO: localFilters.filtroDataContratoInicio
      }),
      ...(localFilters.filtroDataContratoFinal && {
        DATA_CONTRATO_FIM: localFilters.filtroDataContratoFinal
      }),
      ...(localFilters.filtroDataAtivacaoInicio && {
        DATA_ATIVACAO_INICIO: localFilters.filtroDataAtivacaoInicio
      }),
      ...(localFilters.filtroDataAtivacaoFinal && {
        DATA_ATIVACAO_FIM: localFilters.filtroDataAtivacaoFinal
      }),
      ...(localFilters.filtroValorMinimo && {
        VALOR_MIN: localFilters.filtroValorMinimo
      }),
      ...(localFilters.filtroValorMaximo && {
        VALOR_MAX: localFilters.filtroValorMaximo
      }),
      ...(localFilters.filtroCliente && {
        DS_CLIENTE: localFilters.filtroCliente
      })
    }

    despacho(mudarFiltros(filters))
  }
  const formatValue = (value) => {
    const number = typeof value === 'number' ? value : Number(value)

    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  }

  const fetchData = (paramRota) => {
    if(paramRota === 'plans') {
      return api_gateway.get(`/m1/consultar/fatSimcard_plano?cd_pav_usuario=${cd_pav_usuario}`)
    } else {
      return api_gateway.post('/m1/consultar/select', {
        dados: {
          paramCampo1: cd_pav_usuario
        },
        condicao: {
          paramRota: paramRota
        }
      })
    }
  }

  useQuery(['faturas/dispositivos/filters'], getFilters, {
    ...REACT_QUERY_OPTIONS
  })

  const handleLocalFiltroChange = (fieldPath, value) => {
    const [parent, child] = fieldPath.split('.')

    setLocalFilters((prev) => {
      const newFilters = !child
        ? { ...prev, [parent]: value }
        : { ...prev, [parent]: { ...prev[parent], [child]: value } }

      validateDates(newFilters)
      return newFilters
    })
  }

  const handleCleanFilters = () => {
    setLocalFilters({ ...DEFAULT_FILTERS_VALUES })
    despacho(filtrosArrayBarra([]))
    despacho(revelarBarraFiltragem(false))
    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(limpadorFiltros(false))
  }

  return (
    <Modal
      width="1100px"
      type="filtro"
      titulo="Filtros"
      opened={opened}
      close={close}
      onConfirm={handleFuncaoEstadosRedux}
      handleCleanFilters={handleCleanFilters}
    >
      <S.Container>
        <S.Card>
          <Grid colSize={WIDTH_COLUMNS}>
            <S.FieldsWrapper>
              <Input
                label="Valor"
                value={localFilters.filtroValorMinimo}
                placeholder="Min."
                onChange={(e) =>
                  handleLocalFiltroChange('filtroValorMinimo', e.target.value)
                }
              />
              <Input
                placeholder="Max."
                value={localFilters.filtroValorMaximo}
                onChange={(e) =>
                  handleLocalFiltroChange('filtroValorMaximo', e.target.value)
                }
              />
            </S.FieldsWrapper>
            <S.FieldsWrapper>
              <DatePicker
                error={dateErrors.activation}
                label="Data de ativação"
                prefixo="De:"
                value={localFilters.filtroDataAtivacaoInicio}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataAtivacaoInicio', date)
                }
              />
              <DatePicker
                error={dateErrors.activation}
                prefixo="Até:"
                minDate={localFilters.filtroDataAtivacaoInicio}
                value={localFilters.filtroDataAtivacaoFinal}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataAtivacaoFinal', date)
                }
              />
            </S.FieldsWrapper>
            <S.FieldsWrapper>
              <DatePicker
                error={dateErrors.contract}
                label="Prazo de contrato"
                prefixo="De:"
                value={localFilters.filtroDataContratoInicio}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataContratoInicio', date)
                }
              />
              <DatePicker
                error={dateErrors.contract}
                prefixo="Até:"
                minDate={localFilters.filtroDataContratoInicio}
                value={localFilters.filtroDataContratoFinal}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataContratoFinal', date)
                }
              />
            </S.FieldsWrapper>
            <S.FieldsWrapper>
              <DatePicker
                error={dateErrors.purchase}
                label="Data da compra"
                prefixo="De:"
                value={localFilters.filtroDataCompraInicio}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataCompraInicio', date)
                }
              />
              <DatePicker
                error={dateErrors.purchase}
                prefixo="Até:"
                minDate={localFilters.filtroDataCompraInicio}
                value={localFilters.filtroDataCompraFinal}
                onChange={(date) =>
                  handleLocalFiltroChange('filtroDataCompraFinal', date)
                }
              />
            </S.FieldsWrapper>
          </Grid>
        </S.Card>
        <S.Card>
          <Grid colSize={WIDTH_COLUMNS}>
            <Input
              label="Nome do cliente"
              placeholder="Insira o nome do cliente"
              value={localFilters.filtroCliente}
              onChange={(e) =>
                handleLocalFiltroChange('filtroCliente', e.target.value)
              }
            />
            <MultiSelect
              label="Ciclo de vida"
              searchable
              options={filterOptions.cicles}
              value={localFilters.dsCicloVida}
              onChange={(value) =>
                handleLocalFiltroChange('dsCicloVida', value)
              }
            />
            <MultiSelect
              label="Fornecedor"
              searchable
              options={filterOptions.suppliers}
              value={localFilters.dsFornecedor}
              onChange={(value) =>
                handleLocalFiltroChange('dsFornecedor', value)
              }
            />
            <MultiSelect
              label="Plano"
              searchable
              options={filterOptions.plans}
              value={localFilters.dsPlano}
              onChange={(value) => handleLocalFiltroChange('dsPlano', value)}
            />
          </Grid>
        </S.Card>
      </S.Container>
    </Modal>
  )
}
